<template>
  <a class="lease-item" target="_blank" :href="detailURL">
    <YorkbbsImage class="lease-cover" width="100%" height="195px" animation borderRadius="6px"
      :src="coverImage | webpFormat(300)">
      <div class="post-label">
        <div class="post-label__item post-label__top" v-if="isTop">置顶</div>
        <div class="post-label__item post-label__good" v-if="isGood">推荐</div>
        <div class="post-label__item post-label__mark" v-if="markedVisible && isMarked">加急</div>
        <div class="post-label__item post-label__shop" v-if="isCarShop">车行</div>
      </div>
    </YorkbbsImage>
    <div class="lease-desc">
      <div class="lease-title__wrapper">
        <div class="lease-title e" :title="title">{{ title }}</div>
      </div>
      <div class="lease-extend" v-if="operType == 1">{{ extend1 }}</div>
      <template v-else>
        <div class="lease-time__wrapper e">
          <span class="lease-km">剩余公里数{{ remainingKM | distanceFormat }}km</span>
          <span class="lease-time">{{ lastTime }}到期</span>
        </div>
        <div class="lease-price__wrapper e">
          <div class="lease-payment">
            <span class="lease-price__label" v-if="downPayments >= 0">拿回首付</span>
            <span class="lease-price__label" v-else>首付返现</span>
            <span class="lease-price__num">${{ Math.abs(downPayments) | moneyFormat }}</span>
          </div>
          <div class="lease-monthly">
            <span class="lease-price__label">月供</span>
            <span class="lease-price__num">${{ monthlySupply | moneyFormat }}</span>
          </div>
        </div>
      </template>
    </div>
  </a>
</template>
<script>
export default {
  name: 'ItemLease',
  props: {
    data: Object,
    // 是否显示置顶
    topVisible: {
      type: Boolean,
      default: true,
    },
    // 是否显示加急
    markedVisible: {
      ype: Boolean,
      default: true,
    },
  },
  computed: {
    // 封面图
    coverImage() {
      return this.data.imageList[0];
    },
    // 标题
    title() {
      return this.data.title;
    },
    // 是否置顶
    isTop() {
      return this.data.property.top == 4;
    },
    // 是否推荐
    isGood() {
      return this.data.property.top == 3;
    },
    // 是否是车行
    isCarShop() {
      return this.data.property.source == 2;
    },
    // 剩余公里数
    remainingKM() {
      return this.data.property.remainingKM;
    },
    // 到期时间
    lastTime() {
      const lastTime = this.data.property.lastTime + '' || '',
        year = lastTime.slice(0, 4),
        month = lastTime.slice(4, 6);
      return `${year}-${month}`;
    },
    // 首付
    downPayments() {
      return this.data.property.downPayments;
    },
    // 月供
    monthlySupply() {
      return this.data.property.monthlySupply;
    },
    // 是否加急
    isMarked() {
      return this.data.property.marked == 1;
    },
    // 当前板块
    topic() {
      return this.data.property.topics[0] || {};
    },
    // 详情页地址
    detailURL() {
      return this.operType == 1 ? this.data.url : `/detail/${this.topic.englishName}/${this.data.id}`;
    },
    operType() {
      return this.data.operType;
    },
    extend1() {
      return this.data.property.extend1;
    },
    url() {
      return this.data.url;
    },
  },
};
</script>
<style lang="scss" scoped>
.lease-item {
  box-sizing: border-box;
  padding: 10px;
  display: block;
  width: 280px;
  position: relative;
  border: 1px solid transparent;

  &:hover {
    border-color: #f5f5f5;
    box-shadow: 0 15px 20px rgba($color: #000000, $alpha: 0.1);
    border-radius: 6px;

    .lease-cover {
      border-color: transparent;
    }
  }
}

.lease-cover {
  border: 1px solid #eee;
}

.lease-desc {
  padding: 8px 0;
}

.lease-title__wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  line-height: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.lease-title {
  font-size: 18px;

  &:hover {
    color: var(--primary-color);
  }
}

.lease-time__wrapper {
  font-size: 16px;
  color: var(--text-color-6);
  line-height: 22px;
  margin-bottom: 12px;
}

.lease-km {
  margin-right: 20px;
}

.lease-price__wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  color: var(--primary-color);
  line-height: 28px;

}

.lease-payment,
.lease-monthly {
  display: flex;
  align-items: center;
}

.lease-monthly {
  margin-left: 20px;
  flex: 1;
  overflow: hidden;

}

.lease-price__label {
  font-size: 16px;
  margin-right: 5px;
}

.lease-price__num {
  font-size: 16px;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lease-label {
  width: 75px;
  height: 74px;
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 2;
}

.lease-extend {
  font-size: 14px;
  line-height: 25px;
  color: var(--text-color-9);
}

.post-label {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 1;
  display: flex;
}

.post-label__item {
  width: 50px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border-radius: 4px;
  margin-right: 10px;
}

.post-label__top {
  color: #fff;
  background-color: var(--primary-color);
}

.post-label__good {
  color: #fff;
  background-color: #ff6f06;
}

.post-label__mark {
  color: #fff;
  background-color: #ff6f06;
}

.post-label__shop {
  color: #fff;
  background-color: #ff5806;
}
</style>
